import {
  emailSchema,
  emailUI,
  internationalPhoneUI,
  internationalPhoneSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['your-contact-title']),
    yourEmail: emailUI(content.email),
    yourPhone: internationalPhoneUI(content['primary-phone']),
  },
  schema: {
    type: 'object',
    required: ['yourEmail', 'yourPhone'],
    properties: {
      yourEmail: emailSchema,
      yourPhone: internationalPhoneSchema(),
    },
  },
};
